// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#tramitsbusqueda {
  height: auto;
}

.foldersize {
  height: 18px;
  width: 20px;
}

.titmovil {
  font-size: 1.3rem;
}

.mensajecheck {
  text-align: left;
}

.mat-mdc-raised-button > .mat-icon {
  width: 36px;
  height: 36px;
  padding: 5px;
}

.btn-warning {
  background-color: #FFA429;
  color: #fff;
  border-radius: 8px;
  border-color: #FFA429;
  transition: all 0.3s ease-in;
}

.btn-warning:active, .btn-warning:focus, .btn-warning:hover {
  background-color: #E66819 !important;
  border-color: #E66819 !important;
  transition: all 0.3s ease-in;
  color: #fff !important;
}

@media (max-width: 500px) {
  .lineaButon {
    border: 1px solid #ced4da !important;
    font-size: 0 !important;
  }
  .foldersize {
    height: 24px !important;
    width: 24px !important;
  }
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
